import omit from 'lodash/omit';

import styles from './text.styles';

function getProps(props) {
  return omit(props, ['size', 'children', 'style']);
}

function getStyles(props) {
  const { disabled, size, type, align } = props;

  let typeStyle = type;
  if (disabled) {
    typeStyle += 'Disabled';
  }

  const stylesToMerge = [styles[typeStyle], styles.root];

  if (Array.isArray(props.style)) {
    stylesToMerge.push(...props.style);
  } else if (props.style) {
    stylesToMerge.push(props.style);
  }

  stylesToMerge.push(styles[size]);

  if (align) stylesToMerge.push(styles[align]);

  return stylesToMerge;
}

function getFontSize(props) {
  const propsStyles = getStyles(props);

  if (!Array.isArray(propsStyles)) {
    return propsStyles.fontSize;
  }

  return propsStyles.reduce((acc, style) =>
    (style && style.fontSize != null ? style.fontSize : acc)
  , null);
}

export {
  getProps,
  getStyles,
  getFontSize,
};
